type AssignManagersParams = (managers: Array<string>, areaId: string) => void
export const withAreaId =
  (fn: AssignManagersParams, areaId?: string) => (managers: Array<string>) =>
    areaId && fn(managers, areaId)
